module.exports = __webpack_public_path__ + "static/media/Artboard – 10.ab9ab75d.svg";